class FaqAccordion extends HTMLElement {
    connectedCallback() {
        this.singleOpen = this.hasAttribute('data-single-open');
        this.items = Array.from(this.querySelectorAll('details'));

        if (!this.singleOpen) return;

        this.items.forEach((item) => {
            item.addEventListener('toggle', () => {
                if (!item.open) return;
                this.items.forEach((other) => {
                    if (other !== item) other.open = false;
                });
            });
        });
    }
}

if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', FaqAccordion);
}